module.exports = __webpack_public_path__ + "static/media/pointing-right-stretched-black-outline.70d69530.svg";